export default __webpack_public_path__ + "static/logo_client_walsh@2x-5916878c0acb4e4890d7f0af7a8be185.png";